var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_5375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.45671 6.00008V14.0001H0.790039V6.00008H3.45671ZM6.12337 14.0001C5.76975 14.0001 5.43061 13.8596 5.18056 13.6096C4.93051 13.3595 4.79004 13.0204 4.79004 12.6667V6.00008C4.79004 5.63341 4.93671 5.30008 5.18337 5.06008L9.57004 0.666748L10.2767 1.37341C10.4567 1.55341 10.57 1.80008 10.57 2.07341L10.55 2.28675L9.91671 5.33341H14.1234C14.8634 5.33341 15.4567 5.93341 15.4567 6.66675V8.00008C15.4567 8.17341 15.4234 8.33341 15.3634 8.48675L13.35 13.1867C13.15 13.6667 12.6767 14.0001 12.1234 14.0001H6.12337ZM6.12337 12.6667H12.1434L14.1234 8.00008V6.66675H8.26337L9.01671 3.12008L6.12337 6.02008V12.6667Z",
    fill: "#A1C43A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_5375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.123047)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbup);
export default __webpack_public_path__ + "static/media/thumbup.929d8e1299377a63f27321f90e78176c.svg";
export { ForwardRef as ReactComponent };